<template>
  <div class="action-container">
    <v-btn
      v-if="isShowStatusActionBtn(authorization.privileges, dataType.PrivilegeCode.SEND_TO_AGENT_REVIEW, dataType.PrivilegeType.EXECUTABLE)"
      dark
      small
      tile
      color="primary"
      class="btn-action"
      @click="submitLoan(LoanStatus.AGENT_REVIEW.value)">
      To Agent
    </v-btn>
    <v-btn
      v-if="isShowStatusActionBtn(authorization.privileges, dataType.PrivilegeCode.SEND_TO_UNDERWRITER_REVIEW, dataType.PrivilegeType.EXECUTABLE)"
      dark
      small
      tile
      color="primary"
      class="btn-action"
      @click="submitLoan(LoanStatus.UNDERWRITER_REVIEW.value)">
      To Application Review
    </v-btn>
    <v-btn
      v-if="isShowStatusActionBtn(authorization.privileges, dataType.PrivilegeCode.SEND_TO_TRIBE_REVIEW, dataType.PrivilegeType.EXECUTABLE)"
      dark
      small
      tile
      color="primary"
      class="btn-action"
      @click="submitLoan(LoanStatus.TRIBE_REVIEW.value)">
      Recommendation for Approval
    </v-btn>
    <v-btn
      v-if="isShowStatusActionBtn(authorization.privileges, dataType.PrivilegeCode.SEND_TO_CORRECTOR_REVIEW, dataType.PrivilegeType.EXECUTABLE)"
      dark
      small
      tile
      color="warning"
      class="btn-action"
      @click="submitLoan(LoanStatus.CORRECTOR_REVIEW.value)">
      To Corrector
    </v-btn>
    <v-btn
      v-if="isShowStatusActionBtn(authorization.privileges, dataType.PrivilegeCode.TRIBE_DENY_LOAN, dataType.PrivilegeType.EXECUTABLE)"
      dark
      small
      tile
      color="error"
      class="btn-action"
      @click="handleLoanAction">
      Deny
    </v-btn>
    <v-btn
      v-if="isShowStatusActionBtn(authorization.privileges, dataType.PrivilegeCode.SEND_TO_TRIBE_NOAA_REVIEW, dataType.PrivilegeType.EXECUTABLE)"
      dark
      small
      tile
      color="error"
      class="btn-action"
      @click="submitLoan(LoanStatus.TRIBE_NOAA_REVIEW.value)">
      {{ loan.loanStatus === LoanStatus.UNDERWRITER_REVIEW.value ? 'RECOMMENDATION FOR DENIAL' : 'TO NOAA REVIEW' }}
    </v-btn>
    <v-btn
      v-if="isShowStatusActionBtn(authorization.privileges, dataType.PrivilegeCode.TRIBE_APPROVE_LOAN, dataType.PrivilegeType.EXECUTABLE)"
      dark
      small
      tile
      color="success"
      class="btn-action"
      @click="submitLoan(LoanStatus.APPROVED.value)">
      Approve
    </v-btn>

    <v-dialog v-model="display.toTribeDialog" max-width="600px" persistent>
      <to-tribe-dialog :loan="loan" @hideDialog="hideDialog"></to-tribe-dialog>
    </v-dialog>
    <v-dialog v-model="display.toTribeNoScoreDialog" max-width="800px" persistent>
      <to-tribe-no-score-dialog :loan="loan" @hideDialog="hideDialog"></to-tribe-no-score-dialog>
    </v-dialog>
    <v-dialog v-model="display.toCorrectorDialog" max-width="650px" persistent>
      <to-corrector-dialog :loan="loan" :authorization="authorization" @hideDialog="hideDialog"></to-corrector-dialog>
    </v-dialog>
    <v-dialog v-model="display.denyDialog" max-width="1300px" persistent>
      <deny-dialog :loan="loan" @hideDialog="hideDialog" @updateLoanStatusAndAddNote="updateLoanStatusAndAddNote"></deny-dialog>
    </v-dialog>
    <v-dialog v-model="display.tribeDenyDialog" max-width="600px" persistent>
      <tribe-deny-dialog @hideDialog="hideDialog" @updateLoanStatusAndAddNote="updateLoanStatusAndAddNote" :loanScore="loanScore"></tribe-deny-dialog>
    </v-dialog>
    <v-dialog v-model="display.approveDialog" max-width="800px" persistent>
      <approve-dialog @hideDialog="hideDialog" @updateLoanStatus="updateLoanStatus" :loanScore="loanScore"></approve-dialog>
    </v-dialog>
  </div>
</template>

<script>
import ToTribeDialog from '@/components/panda/pre-origination/dialog/statusAction/ToTribeDialog'
import ToCorrectorDialog from '@/components/panda/pre-origination/dialog/statusAction/ToCorrectorDialog'
import ToTribeNoScoreDialog from '@/components/panda/pre-origination/dialog/statusAction/ToTribeNoScoreDialog'
import DenyDialog from '@/components/panda/pre-origination/dialog/statusAction/DenyDialog'
import TribeDenyDialog from '@/components/panda/pre-origination/dialog/statusAction/TribeDenyDialog'
import ApproveDialog from '@/components/panda/pre-origination/dialog/statusAction/ApproveDialog'

import { OriginationBusinessApi, OriginationApi, LoanOperationApi, RightPanelApi } from '@/api/pandaria'
import { Authentication, DataType, Tool, Popup } from '@/util/index'
import { SystemEnum } from '@/assets/js'

const tool = new Tool()
const popup = new Popup()
export default {
  name: 'status-action',
  components: {
    ToTribeDialog,
    ToTribeNoScoreDialog,
    ToCorrectorDialog,
    DenyDialog,
    TribeDenyDialog,
    ApproveDialog
  },
  props: {
    loan: Object,
    authorization: Object
  },
  data () {
    return {
      LoanStatus: DataType.LoanStatus,
      denyDialog: false,
      display: {
        toTribeDialog: false,
        toTribeNoScoreDialog: false,
        toCorrectorDialog: false,
        denyDialog: false,
        approveDialog: false,
        tribeDenyDialog: false
      },
      assist: {
        tool: new Tool()
      },
      loanScore: null,
      dataType: DataType,
      currentLockedId: -1
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  watch: {
    loanId (value) {
      this.loanScore = this.loan.totalScore
    }
  },
  destroyed () {
    this.$eventBus.$off('updateLoanScore')
    this.$eventBus.$off('initLoanScore')
    this.$eventBus.$off('broadcastLockedId')
  },
  mounted () {
    this.$eventBus.$on('updateLoanScore', target => {
      if (tool.isNotEmpty(target)) {
        this.loanScore = target.totalScore
      }
    })
    this.$eventBus.$on('initLoanScore', target => {
      if (tool.isNotEmpty(target)) {
        this.loanScore = target.totalScore
      }
    })
    this.$eventBus.$on('broadcastLockedId', target => {
      this.currentLockedId = target
    })
  },
  methods: {
    handleLoanAction () {
      if (this.loan.loanStatus === this.dataType.LoanStatus.TRIBE_REVIEW.value) {
        this.submitLoan(this.dataType.LoanStatus.POSITIVE_WITHDRAWN.value)
      } else if (this.loan.loanStatus === this.dataType.LoanStatus.TRIBE_NOAA_REVIEW.value) {
        const $this = this
        const request = {
          loanId: $this.loan.id
        }
        popup.popupForQuestion('Do you want to deny this data?', { title: 'Please confirm' }, function () {
          OriginationBusinessApi.verifyLoanStatus(request, function () {
            const status = request.status
            $this.$eventBus.$emit('updateStatus', { status })
            popup.popupForSuccess('Operation is successful')
          }, function (failure) {
            popup.popupForWarning('Failure')
          })
        })
      }
    },
    judgePrivilegeAndLock (privileges, code, privilege) {
      return Authentication.matchElementPrivilege(privileges, code, privilege) &&
        Authentication.isLockedByCurrentUser(this.store.getters.getAccount, this.currentLockedId)
    },
    isOperational () {
      for (const item of this.authorization.restricts) {
        if (Object.prototype.hasOwnProperty.call(item, 'loanStatus') &&
          item.loanStatus === this.loan.loanStatus) {
          return true
        }
      }
      return false
    },
    isShowStatusActionBtn (privileges, code, privilege) {
      if (!(this.judgePrivilegeAndLock(privileges, code, privilege) && this.isOperational())) {
        return false
      }
      switch (code) {
        case DataType.PrivilegeCode.SEND_TO_AGENT_REVIEW: {
          return [this.dataType.LoanStatus.CUSTOMER_REVIEW.value,
            this.dataType.LoanStatus.PENDING_ORIGINATION.value, this.dataType.LoanStatus.TRIBE_NOAA_REVIEW.value].indexOf(this.loan.loanStatus) !== -1 &&
            this.loan.category !== DataType.CategoryEnum.JARVIS.value
        }
        case DataType.PrivilegeCode.SEND_TO_CORRECTOR_REVIEW: {
          return [this.dataType.LoanStatus.UNDERWRITER_REVIEW.value,
            this.dataType.LoanStatus.TRIBE_REVIEW.value, this.dataType.LoanStatus.TRIBE_NOAA_REVIEW.value].indexOf(this.loan.loanStatus) !== -1
        }
        case DataType.PrivilegeCode.SEND_TO_UNDERWRITER_REVIEW: {
          return [this.dataType.LoanStatus.AGENT_REVIEW.value,
            this.dataType.LoanStatus.CORRECTOR_REVIEW.value,
            this.dataType.LoanStatus.TRIBE_REVIEW.value].indexOf(this.loan.loanStatus) !== -1
        }
        case DataType.PrivilegeCode.SEND_TO_TRIBE_REVIEW: {
          return this.loan.loanStatus === this.dataType.LoanStatus.UNDERWRITER_REVIEW.value
        }
        case DataType.PrivilegeCode.TRIBE_DENY_LOAN: {
          return [this.dataType.LoanStatus.TRIBE_REVIEW.value, this.dataType.LoanStatus.TRIBE_NOAA_REVIEW.value].indexOf(this.loan.loanStatus) !== -1
        }
        case DataType.PrivilegeCode.TRIBE_APPROVE_LOAN: {
          return this.loan.loanStatus === this.dataType.LoanStatus.TRIBE_REVIEW.value
        }
        case DataType.PrivilegeCode.SEND_TO_TRIBE_NOAA_REVIEW: {
          return [this.dataType.LoanStatus.AGENT_REVIEW.value,
            this.dataType.LoanStatus.CORRECTOR_REVIEW.value,
            this.dataType.LoanStatus.UNDERWRITER_REVIEW.value].indexOf(this.loan.loanStatus) !== -1
        }
        default: return false
      }
    },
    submitLoan (status) {
      const $this = this
      switch (status) {
        case DataType.LoanStatus.AGENT_REVIEW.value:
          $this.popupUpdateStatus(status, 'Do you want to send this loan to agent review?')
          break
        case DataType.LoanStatus.UNDERWRITER_REVIEW.value:
          OriginationApi.getLoanSignData($this.loanId, function (result) {
            if (tool.isNotEmpty(result) && result.signStatus === DataType.SignStatusEnum.SIGNED.value) {
              $this.popupUpdateStatus(status, 'Do you want to send this loan to Application review?')
            } else {
              popup.popupForWarning('The Loan agreement has not been signed yet', { title: 'Please confirm' })
            }
          })
          break
        case DataType.LoanStatus.TRIBE_REVIEW.value:
          OriginationApi.getLoanSignData(
            $this.loanId,
            function (result) {
              if (tool.isNotEmpty(result) && result.signStatus === DataType.SignStatusEnum.SIGNED.value) {
                if ($this.store.getters.getPortfolioJson.isScore && parseInt($this.store.getters.getPortfolioJson.isScore) === SystemEnum.BOOLEAN_NUMBER.TRUE.value) {
                  $this.display.toTribeDialog = true
                } else {
                  $this.display.toTribeNoScoreDialog = true
                }
              } else {
                popup.popupForWarning('The Loan agreement has not been signed yet', { title: 'Please confirm' })
              }
            })
          break
        case DataType.LoanStatus.CORRECTOR_REVIEW.value:
          RightPanelApi.listAuditRecordDetails(this.loanId, function (result) {
            if (tool.isEmpty(result)) {
              popup.popupForWarning('Please select at least a correction reason in Audit Panel')
            } else {
              if ($this.loan.loanStatus === DataType.LoanStatus.TRIBE_REVIEW.value) {
                $this.popupUpdateStatus(status, 'Do you want to send this loan to corrector review?')
              } else {
                $this.display.toCorrectorDialog = true
              }
            }
          })
          break
        case DataType.LoanStatus.POSITIVE_WITHDRAWN.value:
          if (this.loan.loanStatus === DataType.LoanStatus.TRIBE_REVIEW.value) {
            this.display.tribeDenyDialog = true
          } else {
            this.display.denyDialog = true
          }
          break
        case DataType.LoanStatus.TRIBE_NOAA_REVIEW.value:
          this.display.denyDialog = true
          break
        case DataType.LoanStatus.APPROVED.value: {
          const loanScore = this.loanScore
          OriginationApi.getLoanSignData(
            $this.loanId,
            function (result) {
              if (tool.isNotEmpty(result) && result.signStatus === DataType.SignStatusEnum.SIGNED.value) {
                if (tool.isEmpty($this.store.getters.getPortfolioJson.isScore) || parseInt($this.store.getters.getPortfolioJson.isScore) === SystemEnum.BOOLEAN_NUMBER.FALSE.value) {
                  $this.popupUpdateStatus(status, 'Do you really want to approve it?')
                } else {
                  if (tool.isEmpty(loanScore)) {
                    popup.popupForWarning('The current application has not been scored yet!', { title: 'Please confirm' })
                  } else if (loanScore <= 4) {
                    $this.display.approveDialog = true
                  } else if (loanScore >= 5) {
                    $this.popupUpdateStatus(status, 'Do you really want to approve it?')
                  }
                }
              } else {
                popup.popupForWarning('The Loan agreement has not been signed yet', { title: 'Please confirm' })
              }
            })

          break
        }
        default:
          break
      }
    },
    popupUpdateStatus (status, message) {
      const $this = this
      popup.popupForInfo(message,
        {
          title: 'Please confirm',
          showCancelButton: true
        }, function () {
          $this.updateLoanStatus(status)
        }
      )
    },
    updateLoanStatusAndAddNote (data) {
      const targetStatus = data.targetStatus
      const note = data.note
      const reasonCode = data.reasonCode
      const denyCode = data.denyCode
      const underwriterApproval = data.underwriterApproval
      this.updateLoanStatus(targetStatus, note, reasonCode, denyCode, underwriterApproval)
    },
    updateLoanStatus (status, note, reasonCode, denyCode, underwriterApproval) {
      const $this = this
      const request = {
        loanId: $this.loan.id,
        status: status
      }
      if (tool.isNotEmpty(underwriterApproval)) {
        underwriterApproval.loanId = $this.loan.id
        request.underwriterApproval = underwriterApproval
      }
      if (tool.isNotEmpty(reasonCode)) {
        request.reasonCode = reasonCode
      }
      if (tool.isNotEmpty(denyCode)) {
        request.denyCode = denyCode
      }
      /*
       * 1. 状态是Agent Review/Corrector Review -> UnderWriter Review 会进行黑名单校验
       * 2. 当有数据存在黑名单时，有跳过校验权限的role 弹窗提示是否继续推送，确认则继续推送状态，否则禁止推送
       * 3. 当没有数据存在黑名单时，则正常推送状态
       */
      if (($this.loan.loanStatus === DataType.LoanStatus.AGENT_REVIEW.value || $this.loan.loanStatus === DataType.LoanStatus.CORRECTOR_REVIEW.value) &&
        status === DataType.LoanStatus.UNDERWRITER_REVIEW.value) {
        const isSkipCheckBlackList = $this.judgePrivilegeAndLock($this.authorization.privileges, DataType.PrivilegeCode.IS_SKIP_CHECK_BLACK_LIST, DataType.PrivilegeType.EXECUTABLE)
        const getBlackListRequest = {
          loanId: $this.loan.id,
          feature: 'BLACK_LIST'
        }
        OriginationApi.listSectionFeature(getBlackListRequest, function (callbackData) {
          if (tool.isNotEmpty(callbackData)) {
            if (isSkipCheckBlackList) {
              popup.popupForWarning('Some parameters of this loan are still in the blacklist. Do you want to continue pushing?', { showCancelButton: true }, function () {
                $this.changeLoanStatus(request, note)
              })
            } else {
              popup.popupForWarning('Some parameters of this loan are still in the blacklist.')
            }
          } else {
            $this.changeLoanStatus(request, note)
          }
        })
      } else {
        $this.changeLoanStatus(request, note)
      }
    },
    changeLoanStatus (request, note) {
      const $this = this
      OriginationBusinessApi.changeLoanStatus(request, function () {
        if (tool.isNotEmpty(note)) {
          LoanOperationApi.addNote({ loanId: $this.loanId, noteContent: note })
        }

        const withdrawnValue = DataType.LoanStatus.POSITIVE_WITHDRAWN.value
        const status = request.status
        if ($this.loan.loanStatus === DataType.LoanStatus.TRIBE_REVIEW.value &&
          (status === DataType.LoanStatus.APPROVED.value || status === withdrawnValue)
        ) {
          $this.$eventBus.$emit('broadcastAutoGenerateLoan', { loanStatus: $this.loan.loanStatus, updatedStatus: status })
        } else if (($this.loan.loanStatus === DataType.LoanStatus.CUSTOMER_REVIEW.value ||
            $this.loan.loanStatus === DataType.LoanStatus.PENDING_ORIGINATION.value) &&
          status === DataType.LoanStatus.AGENT_REVIEW.value) {
          $this.$eventBus.$emit('updateStatus', { status })
        } else {
          $this.$eventBus.$emit('updateStatus', { status })
          $this.$eventBus.$emit('forceUnlock', { unlockReason: DataType.UnlockLoanReasonEnum.STATUS_CHANGED.value })
        }

        popup.popupForSuccess('Operation is successful')
      }, function (result) {
        popup.popupForWarning(result.message)
      })
    },
    hideDialog (type) {
      switch (type) {
        case 'TO_TRIBE':
          this.display.toTribeDialog = false
          break
        case 'TO_TRIBE_NO_SCORE':
          this.display.toTribeNoScoreDialog = false
          break
        case 'TO_CORRECTOR':
          this.display.toCorrectorDialog = false
          break
        case 'DENY':
          this.display.denyDialog = false
          break
        case 'APPROVE':
          this.display.approveDialog = false
          break
        case 'TRIBE_DENY':
          this.display.tribeDenyDialog = false
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="css" scoped>
  .action-container {
    position: fixed;
    bottom: 10px;
    z-index: 2;
  }

  .btn-action {
    /* width: 150px; */
    margin: 0;
  }
  .btn-action + .btn-action {
    margin-left: 3px;
  }
</style>
